<template>
  <div class="content">
    <div @click.stop="cutEdit">
      <div class="box">
        <div class="box-f">
          <span v-if="!isTestEdit && !istestPreview && !isBankViewTest">{{ question.quesIndex + 1 }}</span>
          <div style="padding: 0px 10px;box-sizing: border-box;width: 80%;" @click="setActiveInput(question.qid)">
            <span v-if="(isBankViewTest || istestPreview) && question.questionsName">{{question.questionsName}}</span>
            <TitleEditor 
              :actionTitleEditorShow="activeInputId === question.qid"
              v-if="!isBankViewTest && !istestPreview" 
              class="outline-none" 
              :qid="question.qid" 
              :class="question.qid"  
              :value="question.questionsName" 
              @childValueChange="val=>{ question.questionsName = val }" 
            ></TitleEditor>
          </div>
            <span class="title-score">（最高分值：{{question.score}}分）</span>
        </div>
        <OperateaWrap 
          v-if="!isTestEdit && !istestPreview && !istestPreview" 
          :isBank="isBank"
          :isBankViewTest="isBankViewTest"
          :question="question"
          :bankList="bankList"
          @getBankList="$emit('getBankList')"
          @addToBank="(question, id) => $emit('addToBank', question, id)"
          @addBank="(bankForm, qid) => $emit('addBank', bankForm, qid)"
          @copyQuestion="copyQuestion"
          @delQuestion="delQuestion"
          @delFormBank="(question) => $emit('delFormBank', question)"
        />
      </div>
      <div class="box-c">
        <!-- 填空 简答 -->
        <el-row  v-if="question.questionsTypeId == 204 || question.questionsTypeId == 206">
          <el-col
            :xs="16"
            :sm="16"
            :md="16"
            :lg="16"
            :xl="16"
            class="el_item_option item_container_title"
          >
            <div class="imitation-form-input-text imitation-form-small" 
              :style="{height: question.inputHeight == '小' ? '32px' : (question.inputHeight == '中' ? '51px' : '70px')}">
            </div>
          </el-col>
        </el-row>
        
        <!-- 多项填空 横向填空 -->
        <ul class="option" v-if="question.questionsTypeId == 207 || question.questionsTypeId == 208">
          <template v-if="question.questionsTypeId == 207">
            <draggable
              style="width: 100%;"
              v-bind="draggableOptions"
              v-model="question.optionList"
            >
              <transition-group
                style="width: 100%;"
                tag="div"
                type="transition"
                :name="'flip-list'"
              >
                <li
                  class="option-li"
                  :label="it.labelName"
                  v-for="(it, indexoption) in question.optionList"
                  :key="it.oid"
                >
                  <div 
                    style="display: flex"
                    @mouseenter="editOptionIndex = indexoption"
                    @mouseleave="editOptionIndex = -1"
                  >
                  <div class="option-li-div" @click="setActiveInput(it.oid)">
                    <TitleEditor 
                      v-if="!isBankViewTest && istestPreview" 
                      class="outline-none" 
                      :actionTitleEditorShow="activeInputId === it.oid"
                      :qid="it.oid" 
                      :class="it.oid"  
                      :value="it.labelName" 
                      @childValueChange="val=>{ it.labelName = val }" 
                    ></TitleEditor>
                    <span v-if="it.labelName && (isBankViewTest || istestPreview) ">{{it.labelName}}</span>
                  </div>
                  <div class="control">
                    <el-tooltip placement="top" effect="light">
                      <div slot="content">长按拖动</div>
                      <i v-if="!istestPreview && !isBankViewTest" v-show="editOptionIndex == indexoption" class="option-handle el-icon-rank delicon" ></i>
                    </el-tooltip>
                    <el-tooltip placement="top" effect="light">
                      <div slot="content">设置</div>
                      <i
                        v-if="!istestPreview && !isBankViewTest"
                        class="el-icon-s-tools delicon"
                        v-show="editOptionIndex == indexoption"
                        @click="optionAction = question.optionList[indexoption]"
                      ></i>
                    </el-tooltip>
                    
                    
                    <el-tooltip placement="top" effect="light">
                      <div slot="content">删除</div>
                      <i
                        v-if="!istestPreview && !isBankViewTest"
                        class="el-icon-remove delicon"
                        v-show="editOptionIndex == indexoption"
                        @click="delOptionOne(it.oid, indexoption)"
                      ></i>
                    </el-tooltip>
                  </div>
                  </div>
                  <el-row v-if="question.questionsTypeId == 207">
                    <el-col
                      :xs="16"
                      :sm="16"
                      :md="16"
                      :lg="16"
                      :xl="16"
                      class="el_item_option item_container_title"
                    >
                      <div class="imitation-form-input-text imitation-form-small" 
                        :style="{height: it.inputHeight == '小' ? '32px' : (it.inputHeight == '中' ? '51px' : '70px')}">
                      </div>
                    </el-col>
                  </el-row>
                </li>
              </transition-group>
            </draggable>
          </template>
          <li 
            class="quesOptionTitle-box"
            v-if="question.questionsTypeId == 208" 
            @mouseenter="isQuesOptionTitle = true"
            @mouseleave="isQuesOptionTitle = false"
          >
              <div style="width: 70%;" @click="setActiveInput(`OptionTitle${question.qid}`)">
                <TitleEditor 
                  v-if="!isBankViewTest && !istestPreview" 
                  class="outline-none quesOptionTitle" 
                  :qid="`OptionTitle${question.qid}`" 
                  :class="`OptionTitle${question.qid}`"  
                  :value="question.quesOptionTitle" 
                  :actionTitleEditorShow="activeInputId === `OptionTitle${question.qid}`"
                  @childValueChange="childValueChange" 
                ></TitleEditor>
                <span v-else-if="question.quesOptionTitle && (isBankViewTest || istestPreview) ">{{question.quesOptionTitle}}</span>
              </div>
              <template v-if="!isBankViewTest && !istestPreview" >
                <el-tooltip placement="top" effect="light">
                  <div slot="content">设置</div>
                  <i
                    class="el-icon-s-tools delicon"
                    v-show="isQuesOptionTitle"
                    @click="horizontalSet()"
                  ></i>
                </el-tooltip>
                <el-tooltip placement="right" effect="light">
                  <div slot="content">每个填空符为2个汉字宽度，可连续输<br>入，其长短决定答题填空宽度，可用<br>键盘删除键回退内容</div>
                  <i
                    class="el-icon-question delicon"
                    v-show="isQuesOptionTitle"
                  ></i>
                </el-tooltip>
              </template>
          </li>
        </ul>
      </div>
    </div>
    <!-- 编辑模态 -->
    <div v-if="question.isedit && !istestPreview && !isBankViewTest" class="option-bottom">
      <template v-if="question.questionsTypeId == 207">
        <el-button type="text" @click="addOption">添加选项</el-button>
        <el-button type="text" @click="isdialogshow = true">批量添加</el-button>
      </template>
      <el-button type="text" @click="setAnswer">设置答案解析</el-button>
    </div>
    <!-- 填空 简答设置 -->
    <div v-if="(question.isedit && !istestPreview && !isBankViewTest) && (question.questionsTypeId == 204 || question.questionsTypeId == 206)" class="subject-warp">
      <h4 class="title-h4">Q{{ question.quesIndex + 1 }}题目设置</h4>
      <div class="subject-box">
        <!-- 左边的 -->
        <ul class="subject-left">
          <li class="subject">
            <span>此题必答</span>
            <div>
              <el-checkbox v-model="question.mustanswer" ></el-checkbox>
            </div>
          </li>
          <li class="subject">
            <span>输入框高度</span>
            <el-select size="mini"
              v-model="question.inputHeight"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="(item, index) in inputHeightList"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </li>
          <div class="subject">
            <span>格式切换</span>
            <el-select @change="formatChange(question)" size="mini" v-model="question.format" filterable placeholder="不限" :popper-append-to-body="false">
              <el-option v-for="el in formatList" :key="el.value" :label="el.label" :value="el.value"></el-option>
            </el-select>
          </div>
          <div v-if="question.format == '1'" class="subject">
            <span>位数限制 保留小数点位数</span>
            <div style="display: inline-block; margin-left: 10px">
              <el-select v-model="question.decimalPlaces" placeholder="请选择" size="mini">
                <el-option v-for="item in 6" :key="item - 1" :label="item - 1" :value="item - 1"></el-option>
              </el-select>
            </div>
          </div>
          <li  v-if="question.format != 5 && question.format != 6 && question.format != 7" class="subject">
            <span v-if="question.format == '1'">最大值</span>
            <span v-else>字数限制</span>
            <div class="subject-but">
              
              <PopoverNum
                controls-position="right"
                :value="question.minNum"
                :size="'mini'"
                :min="question.minNum"
                :max="question.maxNum"
                :type="'min<max'"
                :maxlength="4"
                :content="question.format == '1' ? '最小值不得大于等于最大值' : '最少字数不得大于等于最大字数'"
                :valueType="question.format == '1' ? 'numValue' : 'lengthValue'"
                @valueChange="(val) => question.minNum = val"
              >
              </PopoverNum>
              至
              <PopoverNum
                controls-position="right"
                :value="question.maxNum"
                :size="'mini'"
                :min="question.minNum"
                :max="question.maxNum"
                :type="'min>max'"
                :maxlength="4"
                :content="question.format == '1' ? '最大值不得小于等于最小值' : '最多字数不得小于等于最少字数'"
                :valueType="question.format == '1' ? 'numValue' : 'lengthValue'"
                @valueChange="(val) => question.maxNum = val"
              >
              </PopoverNum>
            </div>
          </li>
          <!-- 需要加判断 -->
          <li class="subject">
            <span>题型切换</span>
            <el-select size="mini"
              v-model="question.questionsTypeId"
              :popper-append-to-body="false"
              placeholder="简答题"
              @change="quesTypeChange"
            >
            <el-option
              v-for="item in quesTypeList"
              :key="item.questionsTypeId"
              :label="item.label"
              :value="item.questionsTypeId">
            </el-option>
            </el-select>
          </li>
          <li class="subject">
            <span>隐藏该题目</span>
            <el-switch
              v-model="question.isHideTitle"
              active-color="#1e90ff"
              inactive-color="#ccc"
            >
            </el-switch>
          </li>
          <!-- 需要加判断 -->
          <li class="subject">
            <span>难易度</span>
            <el-select size="mini"
              v-model="question.difficulty"
              :popper-append-to-body="false"
            >
            <el-option
              v-for="item in difficultyList"
              :key="item.difficulty"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
          </li>
          <li v-if="question.format != 4 && question.format != 5 && question.format != 6 && question.format != 7" class="subject">
            <span>默认文本</span>
            <el-input  size="mini"
              class="placeholder-input" 
              v-model="question.placeholder" 
              placeholder="请输入内容"
              @input="(val) => item.placeholder = $functions.cutStr(val, 255)"
            ></el-input>
          </li>
		  <li class="subject">
		    <span>标签名称</span>
		    <!-- <el-select v-model="question.quesLabelName" :popper-append-to-body="false" placeholder="请选择">
		       <el-option
		         v-for="item in enumByData"
		         :key="item.value"
		         :label="item.value"
		         :value="item.value">
		       </el-option>
		     </el-select> -->
			  <el-input  style="width: 220px;" type="text"  size="mini" placeholder="请输入标签名称" v-model="question.quesLabelName" maxlength="20" show-word-limit></el-input>
		  </li>
        </ul>
        <!-- 右边的 -->
        <ul class="subject-right">
          <li class="subject subject-none">
            <span>答案与分值</span>
            <!-- <el-switch
              active-color="#1e90ff"
              inactive-color="#ccc"
              v-model="question.isHideScore"
            >
            </el-switch> -->
          </li>
          <template v-if="question.questionsTypeId == 204">
            <li class="subject subject-none">
              <span>计分方式</span>
              <el-select  size="mini"
                :popper-append-to-body="false"
                v-model="question.scoringType" 
                placeholder="请选择"
              >
                <el-option
                  v-for="item in scoringTypeList1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </li>
            
            <!-- <li v-if="question.scoringType != 3" class="subject subject-none">
              <span>答案</span>
              <el-input  size="mini"
                type="textarea" 
                resize="none"
                :rows="4"
                maxlength="500"
                show-word-limit 
                class="keyWordInput" 
                v-model="question.answer" 
                placeholder="如果有多个标准答案，请用请用“;”隔开隔开"
              ></el-input>
            </li> -->
          </template>
          <template v-else-if="question.questionsTypeId == 206">
            
              <li class="subject subject-none">
                <span>计分方式</span>
                <el-select  size="mini"
                :popper-append-to-body="false"
                v-model="question.scoringType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in scoringTypeList2"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </li>
              <li v-if="question.scoringType == 4" class="subject subject-none">
                <span></span>
                <el-select  size="mini"
                  :popper-append-to-body="false" 
                  v-model="question.matchingType" 
                  placeholder="请选择"
                  @change="keyWordBlur"
                  >
                  <el-option
                    v-for="(item,index) in scoringTypeList3"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </li>
              <!-- <template v-if="question.scoringType != 3">
                <li class="subject subject-none">
                  <span>关键词</span>
                  <el-input  size="mini"
                    type="textarea" 
                    resize="none"
                    :rows="4"
                    maxlength="500"
                    show-word-limit 
                    class="keyWordInput" 
                    v-model="question.answer" 
                    placeholder="关键词请用分号隔开;"
                    @blur="keyWordBlur"
                  ></el-input>
                </li>
                <li v-if="question.scoringType == 4 && question.matchingType == 3" class="subject subject-none">
                  <span>每答出一个关键词</span>
                  <PopoverNum
                    :value="question.partialScore"
                    :size="'mini'"
                    :min="1"
                    :max="1000"
                    :content="'请输入1-1000以内的数值'"
                    @valueChange="partialScoreChange"
                  >
                  </PopoverNum>
                </li>
              </template> -->
              
          </template>
            
          <li class="subject subject-none">
            <span>此题分值</span>
            <PopoverNum
              controls-position="right"
              :disabled="question.scoringType == 4 && this.question.matchingType == 3"
              :value="question.score"
              :size="'mini'"
              :min="1"
              :max="1000"
              :content="'请输入1-1000以内的数值'"
              @valueChange="(val) => question.score = val"
            >
            </PopoverNum>
          </li>
          <!-- <div class="subject-daan">
            答案解析
            <el-input
            v-model="question.analysis"
              placeholder="请输入内容"
              type="textarea"
              size="medium"
              resize="none"
            ></el-input>
          </div> -->
        </ul>
      </div>
    </div>
    <!-- 多项、横向填空设置 -->
    <div v-else-if="(question.isedit && !istestPreview && !isBankViewTest) && (question.questionsTypeId == 207 || question.questionsTypeId == 208)" class="subject-warp ">
      <h4 class="title-h4">Q{{ question.quesIndex + 1 }}题目设置</h4>
      <div class="subject-box">
        <!-- 左边的 -->
        <ul class="subject-left" v-if="question.optionList.length > 0 && question.questionsTypeId == 207">
            <h4 class="option-h4">{{ optionAction.labelName }}的设置</h4>
            <li class="subject">
              <span>输入框高度</span>
              <el-select size="mini"
                v-model="optionAction.inputHeight"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(item, index) in inputHeightList"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </li>
            
          <li class="subject">
            <span>格式切换</span>
            <el-select size="mini"
             @change="formatChange(optionAction)"
              v-model="optionAction.format"
                :popper-append-to-body="false"
              placeholder="不限"
            >
            <el-option
              v-for="item in formatList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
          </li>
          <div v-if="optionAction.format == '1'" class="subject">
            <span>位数限制 保留小数点位数</span>
            <div style="display: inline-block; margin-left: 10px">
              <el-select  v-model="optionAction.decimalPlaces" placeholder="请选择" size="mini">
                <el-option v-for="item in 6" :key="item - 1" :label="item - 1" :value="item - 1"></el-option>
              </el-select>
            </div>
          </div>
            <li  v-if="optionAction.format != 5 && optionAction.format != 6 && optionAction.format != 7" class="subject">
              <span>字数限制</span>
              <div class="subject-but">
                
                <PopoverNum
                  controls-position="right"
                  :value="optionAction.minNum"
                  :size="'mini'"
                  :min="optionAction.minNum"
                  :max="optionAction.maxNum"
                  :type="'min<max'"
                  :maxlength="4"
                  :content="optionAction.format == '1' ? '最小值不得大于等于最大值' : '最少字数不得大于等于最大字数'"
                  :valueType="optionAction.format == '1' ? 'numValue' : 'lengthValue'"
                  @valueChange="(val) => optionAction.minNum = val"
                >
                </PopoverNum>
                至
                <PopoverNum
                  controls-position="right"
                  :value="optionAction.maxNum"
                  :size="'mini'"
                  :min="optionAction.minNum"
                  :max="optionAction.maxNum"
                  :type="'min>max'"
                  :maxlength="4"
                  :content="optionAction.format == '1' ? '最大值不得小于等于最小值' : '最多字数不得小于等于最少字数'"
                  :valueType="optionAction.format == '1' ? 'numValue' : 'lengthValue'"
                  @valueChange="(val) => optionAction.maxNum = val"
                >
                </PopoverNum>
              </div>
            </li>
          <li  v-if="optionAction.format != 4 && optionAction.format != 5 && optionAction.format != 6 && optionAction.format != 7"  class="subject">
            <span>默认文本</span>
            <el-input  size="mini"
              class="placeholder-input" 
              v-model="optionAction.placeholder" 
              placeholder="请输入内容"
              @input="(val) => item.placeholder = $functions.cutStr(val, 255)"
              ></el-input>
          </li>
          <li class="subject">
            <span>该空必填</span>
            <el-switch
              v-model="optionAction.mustanswer"
              active-color="#1e90ff"
              inactive-color="#ccc"
              :active-value="true"
              :inactive-value="false">
            </el-switch>
          </li>
        </ul>
        <!-- 右边的 -->
        <ul class="subject-right">
          <li class="subject">
            <span>此题必答</span>
            <div>
              <el-checkbox  v-model="question.mustanswer" ></el-checkbox>
            </div>
          </li>
          
          <li class="subject" v-if="question.optionIfRandom != undefined">
            <span>选项随机排列</span>
            <el-switch
              v-model="question.optionIfRandom"
              :active-value="1" 
              :inactive-value="0"
              active-color="#1e90ff"
              inactive-color="#ccc"
            >
            </el-switch>
          </li>
          <li class="subject" v-if="question.optionIfRandom">
            <span>固定最后一个选项</span>
            <el-switch
              v-model="question.ifFixedLastOption"
              active-color="#1e90ff"
              inactive-color="#ccc"
              :active-value="1" 
              :inactive-value="0"
            >
            </el-switch>
          </li>
          <li class="subject">
            <span>隐藏该题目</span>
            <el-switch
              v-model="question.isHideTitle"
              active-color="#1e90ff"
              inactive-color="#ccc"
            >
            </el-switch>
          </li>
          <!-- 需要加判断 -->
          <li  class="subject">
            <span>难易度</span>
            <el-select size="mini"
              v-model="question.difficulty"
              :popper-append-to-body="false"
            >
            <el-option
              v-for="item in difficultyList"
              :key="item.difficulty"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
          </li>
          <li class="subject subject-none">
            <span>答案与分值</span>
            <!-- <el-switch
              active-color="#1e90ff"
              inactive-color="#ccc"
              v-model="question.isHideScore"
            >
            </el-switch> -->
          </li>
          <li class="subject subject-none flex-itemC-none">
            <span>计分方式</span>
            <div class="itemCD">
              <el-select  size="mini"
                :popper-append-to-body="false" 
                @change="scoringTypeChange" v-model="question.scoringType" placeholder="请选择">
                <el-option
                  v-for="(item, index) in scoringTypeList4"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select size="mini"
                :popper-append-to-body="false" v-if="question.scoringType != 3" v-model="question.matchingType" placeholder="请选择">
                <el-option
                  v-for="(item, index) in scoringTypeList5"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </li>
          <!-- <template v-if="question.scoringType != 3">
            <div v-for="(item, oIndex) in question.optionList" :key="item.oid">
              <li class="subject-direction subject-none">
                <p>答案-
                  <span v-if="question.questionsTypeId == 207" v-html="item.labelName"></span>
                  <span v-else-if="question.questionsTypeId == 208">填空{{oIndex + 1}}</span>
                </p>
                <el-input  size="mini"
                  type="textarea" 
                  resize="none"
                  :rows="4"
                  maxlength="500"
                  show-word-limit 
                  v-model="item.answer" 
                  placeholder="如果有多个标准答案，请用“;”隔开"
                ></el-input>
              </li>
              <li v-if="question.scoringType == 2" class="subject subject-none">
                <span>此项分值</span>
                  <PopoverNum
                  :value="item.optionScore"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => optionScoreBlur(val, oIndex)"
                >
                </PopoverNum>
              </li>
            </div>
          </template> -->
            
          <li v-if="question.scoringType != 2" class="subject subject-none">
            <span>此题分值</span>
            <PopoverNum
              controls-position="right"
              :value="question.score"
              :size="'mini'"
              :min="1"
              :max="1000"
              :content="'请输入1-1000以内的数值'"
              @valueChange="(val) => question.score = val"
            >
            </PopoverNum>
          </li>
          <!-- <div class="subject-daan">
            答案解析
            <el-input
            v-model="question.analysis"
              placeholder="请输入内容"
              type="textarea"
              size="medium"
              resize="none"
            ></el-input>
          </div> -->
		  
		  <li class="subject">
		    <span>标签名称</span>
		    <!-- <el-select multiple collapse-tags v-model="question.quesLabelName" :popper-append-to-body="false" placeholder="请选择">
		       <el-option
		         v-for="item in enumByData"
		         :key="item.value"
		         :label="item.value"
		         :value="item.value">
		       </el-option>
		     </el-select> -->
			  <el-input type="text"  style="width: 220px;" size="mini" placeholder="请输入标签名称" v-model="question.quesLabelName" maxlength="20" show-word-limit></el-input>
		  </li>
        </ul>
      </div>
    </div>
    <el-dialog
      title="批量添加选项"
      :visible.sync="isdialogshow" :close-on-click-modal="false"
    >
    <span>每行代表一个填空，可以添加多个填空</span>
      <el-input size="mini"
        type="textarea"
        :rows="5"
        placeholder="填空1"
        v-model="optionBatch"
        resize="none"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelAdd">取 消</el-button>
        <el-button size="medium" type="primary" @click="keepBatch"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 横向填空题设置 -->
    <el-dialog
      title="填空属性"
      :visible.sync="horizontalDialog"
      width="1000px"
      :before-close="() => {horizontalDialog = false}" :close-on-click-modal="false">
      <span style="line-height: 40px;" v-html="question.quesOptionTitle"></span>
      <el-table
        @selection-change="horizontalChange"
        :data="optionList"
        ref="multipleTable"
        border
        style="width: 100%">
        <el-table-column
          label="填空序号"
          width="100"
          align="center">
          <template #default='scope'>{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column
          label="内容限制"
          width="180"
          align="center">
          <template #default='scope'>
            <el-select
              @change="formatChange(scope.row)"
              v-model="scope.row.format"
              :popper-append-to-body="false"
              placeholder="不限"
              size="mini"
              style="width: 130px;"
            >
              <el-option
                v-for="item in formatList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="范围"
          align="center">
          <template #default='scope'>
            <div class="table-range">
                <div class="table-item" v-if="scope.row.format == '1'" >
                    保留小数
                    <el-select v-model="scope.row.decimalPlaces" placeholder="请选择" size="mini" style="width: 130px;">
                        <el-option v-for="item in 6" :key="item - 1" :label="item - 1" :value="item - 1"></el-option>
                    </el-select>
                </div>
                <div v-if="scope.row.minNum  != undefined
                    && 
                    (scope.row.format == '0' 
                    || scope.row.format == '1'
                    || scope.row.format == '2'
                    || scope.row.format == '3'
                    || scope.row.format == '4'
                )"  class="table-item">
                
                    <span v-if="scope.row.format == '1'">最小值 </span>
                    <span v-else>最少字数 </span>
                    <PopoverNum
                        :value="scope.row.minNum"
                        controls-position="right"
                        :size="'mini'"
                        :min="scope.row.minNum"
                        :max="scope.row.maxNum"
                        :type="'min<max'"
                        :maxlength="4"
                        :content="scope.row.format == '1' ? '最小值不得大于等于最大值' : '最少字数不得大于等于最大字数'"
                        :valueType="scope.row.format == '1' ? 'numValue' : 'lengthValue'"
                        @valueChange="(val) => scope.row.minNum = val"
                    >
                        </PopoverNum>
                <!-- <el-input-number 
                    class="range-input"
                    v-model.number="scope.row.maxNum"
                    controls-position="right"
                    :min="1" ></el-input-number> -->
                </div>
                <div v-if="scope.row.maxNum  != undefined
                    && 
                    (scope.row.format == '0' 
                    || scope.row.format == '1'
                    || scope.row.format == '2'
                    || scope.row.format == '3'
                    || scope.row.format == '4'
                )"  class="table-item">
                    <span v-if="scope.row.format == '1'">最大值 </span>
                    <span v-else>最多字数 </span>
                    <PopoverNum
                        :value="scope.row.maxNum"
                        controls-position="right"
                        :size="'mini'"
                        :min="scope.row.minNum"
                        :max="scope.row.maxNum"
                        :type="'min>max'"
                        :maxlength="4"
                        :content="scope.row.format == '1' ? '最大值不得小于等于最小值' : '最多字数不得小于等于最少字数'"
                        :valueType="scope.row.format == '1' ? 'numValue' : 'lengthValue'"
                        @valueChange="(val) => scope.row.maxNum = val"
                    >
                    </PopoverNum>
                </div>
            </div>
            <!-- <div class="itemC">
              最多填写
              <el-input-number 
                class="range-input"
                v-model.number="scope.row.maxNum"
                controls-position="right"
                :max="500"
                :min="1" ></el-input-number>
              字
            </div> -->
          </template>
        </el-table-column>
        <el-table-column
          type="selection"
          label="此空必填"
          width="100"
          align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="horizontalDialog = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="horizontalSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <SetAnswerAnalysis 
      v-if="question.isedit && !istestPreview && !isBankViewTest"
      :data="question" 
      @updata="(val) => $emit('updataQuestion', val)"
      ref="setAnswerAnalysis" 
    />
  </div>
</template>

<script>
import { v1 as UUID } from "uuid"
import { mapActions, mapState } from 'vuex';
import PopoverNum from "@/components/myComponents/popoverNum.vue"
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import CheckType from '@/util/JSON/checkType.json';
import OperateaWrap from './operateaWrap/operateaWrap.vue';
import SetAnswerAnalysis from './operateaWrap/setAnswerAnalysis.vue';
export default {
  name: 'QuestionGap',
  
  components:{
    TitleEditor,
    PopoverNum,
    OperateaWrap,
    SetAnswerAnalysis
  },
  props: {
    question: {},
    qindex: { type: Number, default: 0 },
    // 单独的试题编辑（只能编辑当前试题 不能复制以及 移动）
    isTestEdit: {
        type: Boolean,
        default: false
    },
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
    // 单独试题预览 不能对试题进行操作
    istestPreview: {
        type: Boolean,
        default: false
    },
    bankList: {
        type: Array,
        default: () => {
          return []
        }
    },
    // 题库编辑试题，不能显示是否收藏按钮
    isBank: {
        type: Boolean,
        default: false
    },
  },
  data(){
    return {
		enumByData:[],
      isdialogshow:false,
      optionBatch: '',
      isQuesOptionTitle: false,
      editOptionIndex: -1, //是否操作选项
      optionIndex: 0,
      optionAction: {},
      inputHeightList:['小', '中', '大'],
      quesTypeList: [
        {
          label: "填空题",
          questionsTypeId: 204,
        },
        {
          label: "简答题",
          questionsTypeId: 206,
        },
      ],
      scoringTypeList1: [
        {
          value: 1,
          label: '回答与答案相同才可得分'
        },{
          value: 2,
          label: '回答包含答案即可得分'
        },{
          value: 3,
          label: '人工评分'
        },
      ],
      scoringTypeList2: [
        {
          value: 4,
          label: '回答中包含关键词即可得分'
        },{
          value: 5,
          label: '回答与答案完全相同才可得分'
        },{
          value: 3,
          label: '人工评分'
        },
      ],
      scoringTypeList3: [
        {
          value: 3,
          label: '答出几个关键词得几分'
        },{
          value: 4,
          label: '答出全部关键词才得分'
        }
      ],
      scoringTypeList4: [
        {
          value: 1,
          label: '全部答对才得分'
        },{
          value: 2,
          label: '答对几项得几分'
        },{
          value: 3,
          label: '人工评分'
        }
      ],
      scoringTypeList5: [
        {
          value: 1,
          label: '回答与答案完全相同才得分'
        },{
          value: 2,
          label: '回答中包含答案即可得分'
        }
      ],
      horizontalDialog: false,
      horizontalSetObj: {},
      optionList: [],
      multipleSelection: [],
      difficultyList: [
        {
          label: '易',
          value: 1
        },
        {
          label: '较易',
          value: 2
        },
        {
          label: '中',
          value: 3
        },
        {
          label: '较难',
          value: 4
        },
        {
          label: '难',
          value: 5
        }
      ],
			draggableOptions: {
				handle: '.option-handle'
			},
      defaultOptionList: []
    }
  },
  computed: {
    ...mapState(['activeInputId']),
		//选项验证类型
		formatList () {
			return CheckType
		}
	},
  watch: {
    'question': {
      handler(newV) {
        if(newV.questionsTypeId == 207) {
          if (newV.optionList.length == 0){
            this.optionAction = {}
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    if ( !this.question.difficulty) {
      this.$set(this.question, 'difficulty', 1)
    }
	  this.queryEnumByType()
		// 筛选出默认的选项名和id
		this.getdefaultQuesIdAndName()
  },
  mounted() {
    if (this.question.optionList.length > 0) {
      this.optionAction = this.question.optionList[0]
    }
  },
  methods: {
    ...mapActions(['setActiveInput']),
    getdefaultQuesIdAndName() {
      if (this.question?.qid){
				// 筛选出默认的选项名和id
				this.question?.optionList.forEach((info) => {
					if (info.isDefault) {
						this.defaultOptionList.push(info.oid)
						this.placeholder = this.placeholder ? `${this.placeholder}\n${info.labelName}` : info.labelName
            // console.log('this.placeholder :>> ', this.placeholder, info.labelName);
					}
				})
			}
    },
    formatChange(data) {
      if(data.format != 1) {
        data.decimalPlaces = 0
          if (data.minNum < 0) data.minNum = 0
          if (data.maxNum < 0) data.maxNum = 0
      }

			if (data.format == 5 || data.format == 6 || data.format == 7) {
				data.decimalPlaces = 0
				data.minNum = 0
				data.maxNum = 0
			}
			if (data.format == 4 || data.format == 5 || data.format == 6 || data.format == 7){
				data.placeholder = ''
			}
    },
	  queryEnumByType() {
	  	let that = this;
	  	let params = {
	  		that: this,
	  		url: `${this.$config.service.queryEnumByType}`,
	  		method: 'POST',
	  		data: {
	  			qid: that.wid,
	  			type:'ks',
	  			pageSize: 10000,
	  			currentPage: 1
	  		},
	  		cb(res) {
	  			// console.log(res);
	  			if (res.code == '0') {
	  					that.enumByData = res.resultBody.records;
	  			} else {
	  				that.enumByData =[]
	  				that.$message.error(res.message);
	  			}
	  		}
	  	};
	  	this.$util.request(params);
	  },
    quesTypeChange() {
      if (this.question.questionsTypeId == 204){
        this.question.scoringType = 1
      } else if (this.question.questionsTypeId == 206){
        this.question.scoringType = 4
      }
    },
    horizontalClose() {
      this.horizontalDialog = false
    },
    horizontalChange(val){
      this.multipleSelection = val
    },
    horizontalSet() {
      this.optionList = JSON.parse(JSON.stringify(this.question.optionList))
      this.horizontalDialog = true
      this.$nextTick(() => {
        this.optionList.forEach((info) => {
          if (info.mustanswer) {
              this.$refs.multipleTable.toggleRowSelection(info, true)
          }
        })
      })
    },
    horizontalSubmit() {
      let arr = []
      if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach((el) => {
              arr.push(el.oid)
          })
      }
      this.optionList.forEach(item =>{
          item.mustanswer = false
          if(arr.indexOf(item.oid) != -1) {
              item.mustanswer = true
          }
      })
      this.question.optionList = JSON.parse(JSON.stringify(this.optionList))
      this.horizontalDialog = false
    },
    childValueChange(val){
      this.question.quesOptionTitle = val
      this.quesOptionTitleBlur()
    },
    quesOptionTitleBlur() {
      // this.question.quesOptionTitle = this.$refs.quesOptionTitle.innerHTML
      let arr = this.question.quesOptionTitle.match(/_[_]+_/g)
      let num = arr.length - this.question.optionList.length
        if (num > 0){
            for (let i = 0; i <= num; i++){
                let obj = {
                    oid: UUID(),
                    answer: '',
                    length: 0,
                    labelName: 0,
                    optionScore: 5
                }
                this.question.optionList.push(obj)
            }
            arr.forEach((info, index) => {
                this.question.optionList[index].length = info.length
                this.question.optionList[index].labelName = index
            })
        } else {
            this.question.optionList.length = arr.length
        }
    },
    scoringTypeChange(){
      if (this.question.scoringType === 2) {
        this.question.score = 0
        this.question.optionList.forEach(info =>{
          this.question.score = this.question.score + info.optionScore
        })
      }
    },
    optionScoreBlur(val, oIndex) {
      this.question.optionList[oIndex].optionScore = val
      this.question.score = 0
      this.question.optionList.forEach(info =>{
        this.question.score = this.question.score + info.optionScore
      })
    },
    // 简答题关键词Blur
    keyWordBlur() {
      // 答对几个关键词得几分
      if (this.question.scoringType == 4 && this.question.matchingType == 3) {
        let keyWordNum = this.question.answer.split(';').length || 0
        this.question.score = this.question.partialScore * keyWordNum
      }
    },
    partialScoreChange(e){
      this.question.partialScore = e
      this.keyWordBlur()
    },
    // 编辑选项 动态绑定
    optionBlur(index) {
      this.question.optionList[index].labelName = this.$refs.option[index].innerHTML
    },
    // 点击删除
    delQuestion() {
      // console.log(this.question.qid);
      this.$emit("delQuestion", this.question.qid);
    },
    // 复制当前题目
    copyQuestion(){
      this.$emit("cutEdit");
      this.$emit('copyQuestion', this.question, this.qindex)
    },
    // 点击切换模态框形式
    cutEdit() {
      let state = this.question.isedit
      this.$emit("cutEdit");
      this.question.isedit = true
    },
    // 点击删除一个选项
    delOptionOne(oid, index) {
      // console.log(oid)
      // console.log(this.question)
      this.question.scoreArr.splice(index, 1)
      this.$emit("delOptionOne", { qid: this.question.qid, oid });
      this.scoringTypeChange()
    },
    // 点击添加选项
    addOption() {
      this.$emit("addOption", this.question.qid, [], this.question.questionsTypeId);
      this.scoringTypeChange()
    },
    setAnswer() {
      this.$refs.setAnswerAnalysis.dialogVisible = true
    },
    cancelAdd() {
      this.optionBatch = ''
      this.isdialogshow = false
    },
    // 保存批量添加
    keepBatch(){
      let optionArr = this.optionBatch.split('\n')
      this.delOption()
      this.$emit("addOption", this.question.qid, optionArr, this.question.questionsTypeId);
      this.scoringTypeChange()
      this.cancelAdd()
    },
    delOption() {
      if (this.defaultOptionList.length > 0) {
        this.question.optionList = this.question.optionList.filter((info => !info.isDefault))
      }
    },
  },
};
</script>

<style scoped lang="scss">
.to-bank{
  color: #424542;
}
.form-bank{
  /deep/.el-button [class*=" el-icon-"], .el-button [class^="el-icon-"]{
    color: #409EFF;
  }
}
.outline-none{
  // display: inline-block;
  outline: none;
  // max-width: 73%;
  // margin-top: 5px;
}
.box {
  display: flex;
  justify-content: space-between;
}
.box-f{
  width: 89%;
  font-size: 14px;
  display: flex;
}
.box-f span {
  padding-right: 15px;
}
.title-score{
  color: #ccc;
}
.box-c,
.box-d {
  padding-left: 22px;
  margin-bottom: 10px;
}
.content{
  background-color: rgb(255, 255, 255);
  line-height: 30px;
  padding: 0 10px;
  margin-bottom: 10px;
  
  .option {
    &-true{
      display: inline-block;
      padding: 0 10px;
      font-size: 14;
      color: #409EFF;
    }
    .quesOptionTitle-box{
      display: flex;
      align-items: center;
      .quesOptionTitle{
        max-width: 80%;
      }
    }
    .circle {
      display: block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      border: 1px solid #ccc;
      margin-right: 10px;
    }
    .delicon {
      margin-left: 10px;
      font-size: 16px;
      line-height: 30px !important;
      color: cornflowerblue;
      cursor: pointer;
    }
    .option-li{
      font-size: 14px;
    }
    .option-li-div{
      width: 70%;
      display: flex;
      align-items: center;
      border-radius: 4px;
      padding-left: 10px;
      border: 1px dashed #fff;
      margin-bottom: 5px;
    }
    .option-li:hover{
      .option-li-div{
        border: 1px dashed #aaa;
        background-color: #f4f4f4;
      }
    }
  }
  
  .subject-warp {
    background-color: rgb(255, 255, 255);
    border-top: 1px solid #999;
    font-size: 14px;
    padding-bottom: 20px;

    .title-h4 {
      padding-left: 30px;
    }
    
    .subject-box {
      display: flex;
      justify-content: space-around;
      line-height: 60px;
      .subject-left{
        // width: 24%;
        right: 338px;
      }
      .subject-right {
        background-color: rgba(242, 242, 242, 1);
        padding: 0 20px 20px 20px;
      }
        .subject {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #999;
          align-items: center;
          .placeholder-input {
            width: 64%;
          }
        }
        // .subject-direction{
        //   display: flex;
        //   flex
        // }
        
        .subject-daan {
          line-height: 30px;
        }
        .subject-none {
          border: none;
          line-height: 50px;
        }
    }
        
  }
  .keyWordInput{
    width: 80%;
  }
  
}
/deep/.el-textarea.is-disabled .el-textarea__inner{
    border: 1px solid #DCDFE6;
    background-color: #FFF;
    width: 400px;
}
.itemCD{
    display: flex;
    flex-direction: column;
}
.itemC{
  display: flex;
  align-items: center;
}
.flex-itemC-none{
  align-items: flex-start !important;
}
/deep/.el-table__header .el-table-column--selection .cell .el-checkbox:after {
  content: " 此空必填";
}

/*在谷歌下移除input[number]的上下箭头*/
.el-input__inner[type="number"]::-webkit-outer-spin-button,
/deep/.el-input__inner[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
}

/*在firefox下移除input[number]的上下箭头*/
.el-input__inner[type="number"] {
    -moz-appearance: textfield;
}
.range-input{
  margin: 0 10px;
}
/deep/.el-dropdown-menu{
  min-width: 220px;
}
.table-range{
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .table-item+.table-item{
        margin-left: 2px;
    }
}
</style>